var React = require('react');

function TriangleInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(.90333 0 0 .92349 -5030.436 -9614.337)"},React.createElement("path",{"d":"M7815.48 10748.8a90.746 90.746 0 0 1 78.61-45.4c32.42 0 62.39 17.3 78.6 45.4 131.05 227 392.68 680.2 523.73 907.1a90.848 90.848 0 0 1 0 90.8c-16.22 28.1-46.18 45.4-78.61 45.4H7370.36c-32.43 0-62.39-17.3-78.61-45.4a90.848 90.848 0 0 1 0-90.8c131.05-226.9 392.68-680.1 523.73-907.1Z","fill":"currentColor","transform":"matrix(.60982 0 0 .59651 1129.48 4027.22)"})));
}

TriangleInline.defaultProps = {"width":"678","height":"600","viewBox":"0 0 678 600"};

module.exports = TriangleInline;

TriangleInline.default = TriangleInline;
